export enum GaCustomEvents {
  MetaInformation = 'meta_information',
  SubmitReturn = 'submit_return',
  ChangeAccount = 'change_account',
  Login = 'login',
  CheckoutStep1 = 'checkout_step_1',
  CheckoutStep2 = 'checkout_step_2',
  CheckoutStep3 = 'checkout_step_3',
  CheckoutStep4 = 'checkout_step_4',
  CheckoutStep5 = 'checkout_step_5',
  Purchase = 'purchase',
  FileDownloadError = 'file_download_error',
  NotificationRead = 'notification_read',
  NotificationScroll = 'notificatiom_scrolled_through',
  PricatDownloadError = 'pricat_download_error',
  OrderCreationFromAvailabilityPage = 'order_creation_from_availability_page',
  VideoPlay = 'video_play',
  VideoTutorialSeeMore = 'video_tutorial_see_more',
  VideoTutorialSeeLess = 'video_tutorial_see_less',
  FileDownload = 'file_download',
}

export enum GaCheckoutStepNames {
  SelectOrderType = 'select order type',
  SelectModels = 'select models',
  AddQuantities = 'add_quantities',
  Review = 'review',
  Confirmation = 'confirmation',
}
